
<div [ngStyle]="{ 'display' : airspaceBoundariesService.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">

  <form autocomplete="off"  id="formAirSpaceBoundary" name="formAirSpaceBoundary" #formAirSpaceBoundary="ngForm" class="active">
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Air Space Boundary Description</h4>
          <span> </span>
        </div>

          <div class="input-fields">

            <div>
              <label for="">Identifier</label>
              <input required maxlength="50" type="text" name="airspaceboundaryid" id="airspaceboundaryid" pattern="[a-zA-Z0-9]+" minlength="1"
                [(ngModel)]="selectCoordinatePointService.selectedAirSpaceBoundary.uniqueid"
                (input)="validateAirSpaceBoundaryIdentifier(selectCoordinatePointService.selectedAirSpaceBoundary.uniqueid)"
                alphaNumeric
                #airspaceId="ngModel"
                />
                <span class="error" *ngIf=" (airspaceId.dirty || airspaceId.touched) && airspaceId.errors?.nonAlphaNumeric">
                  Only alphanumeric characters, hyphens and underscores are allowed.
                </span>
            </div>
            <div>
              <label for="">Name</label>
              <input required type="text" id="procedurename" name="procedurename" alphaNumeric minlength="1"
                [(ngModel)]="selectCoordinatePointService.selectedAirSpaceBoundary.name" #name="ngModel"/>
                <span class="error" *ngIf=" (name.dirty || name.touched)
            && name.errors?.nonAlphaNumeric">
              Only alphanumeric characters, hyphens and underscores are allowed.
            </span>
            </div>

          </div>

        <div class="fields__btn">
          <button type="submit" (click)="saveAirspaceBoundaries()"
          [ngClass]="formAirSpaceBoundary.form.valid && projectService.activeProject?.editable? 'blue' : 'gray'"
          [disabled]="!formAirSpaceBoundary.form.valid || !projectService.activeProject?.editable">Save</button>
            <a class="gray" href="#" type="reset" value="Cancel" (click)="tabsService.closeTab()">Cancel</a>
        </div>
      </div>
    </div>


    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Air Space Boundary Coordinate Points</h4>
          <span> </span>
        </div>
        <div class="table-fields">
          <div>
            <label for=""></label>
            <div class="scrollable">
              <table >
                <thead>
                  <tr>
                    <th style="width: 15%;">Id</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col" style="width: 10%;">Latitude</th>
                    <th scope="col" style="width: 10%;">Longitude</th>
                    <th scope="col" style="width: 10%;">Altitude [ft]</th>
                  </tr>
                </thead>
                <tbody>
                  <tr mdbTableCol *ngFor="let el of selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints | sort:'sequencenumber'; let i = index;"
                    (click)="selectCoordinatePointService.selectAirSpaceBoundaryCoordinatePointRow(selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints[i], selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints)"
                    [class.highlighted]="el.coordPoint.isselected">
                    <td *ngIf="!el.coordPoint.published" scope="col" style="width: 6%;">
                      <input required name="id_{{i}}" [(ngModel)]="el.coordPoint.coordpointid" maxlength="5" type="text" [(ngModel)]="el.coordPoint.coordpointid" (blur)="validateAirSpaceBoundaryCoordinatePoints(el.coordPoint)" alphaNumeric/></td>
                    <td *ngIf="el.coordPoint.published" scope="col">{{ el.coordPoint.coordpointid }}</td>

                    <td *ngIf="!el.coordPoint.published" scope="col">
                      <input required [(ngModel)]="el.coordPoint.name" name="name_{{i}}" [disabled]="el.coordPoint.published? true : false" value="{{ el.coordPoint.name }}" alphaNumeric/>
                    </td>
                    <td *ngIf="el.coordPoint.published" scope="col">{{ el.coordPoint.name }}</td>

                    <td scope="col">{{ el.coordPoint.type }}</td>

                    <td *ngIf="!el.coordPoint.published" scope="col" style="width: 10%;"><input [(ngModel)]="el.coordPoint.latitude" name="latitude_{{i}}" [disabled]="el.coordPoint.published? true : false" value="{{ el.coordPoint.latitude }}"/></td>
                    <td *ngIf="el.coordPoint.published" scope="col" style="width: 10%;">{{ el.coordPoint.latitude }}</td>

                    <td *ngIf="!el.coordPoint.published" scope="col" style="width: 10%;"><input [(ngModel)]="el.coordPoint.longitude" name="longitude_{{i}}" [disabled]="el.coordPoint.published? true : false" value="{{ el.coordPoint.longitude }}"/></td>
                    <td *ngIf="el.coordPoint.published" scope="col" style="width: 10%;">{{ el.coordPoint.longitude }}</td>

                    <td scope="col"><input name="altitude_{{i}}" type="number" value="{{ el.coordPoint.minaltitude }}" (blur)="saveProcedureCoordinatePointAltitudeChange($event, el)"/></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="btn">
              <button type="submit" (click)="deleteCoordinatePointFromList()" [ngClass]="selectCoordinatePointService.isAirSpaceBounderCoordinatePointSelected(selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints) ? 'blue' : 'gray'" [disabled]="!selectCoordinatePointService.isAirSpaceBounderCoordinatePointSelected(selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints)">Delete</button>
              <button type="submit" (click)="changePosition('up')" [ngClass]="selectCoordinatePointService.isAirSpaceBounderCoordinatePointSelected(selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints) ? 'blue' : 'gray'" [disabled]="!selectCoordinatePointService.isAirSpaceBounderCoordinatePointSelected(selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints)">Up</button>
              <button type="submit" (click)="changePosition('down')" [ngClass]="selectCoordinatePointService.isAirSpaceBounderCoordinatePointSelected(selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints) ? 'blue' : 'gray'" [disabled]="!selectCoordinatePointService.isAirSpaceBounderCoordinatePointSelected(selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints)">Down</button>
            </div>
          </div>
        </div>
      </div>

      <div class="fields__block__section">
        <div class="title">
          <h4>Air Space Boundary Navaids</h4>
          <span></span>
        </div>
          <div class="table-fields">
            <div>
              <div class="scrollable">
                <table>
                  <thead>
                    <tr>
                      <th>Identification</th>
                      <th scope="col">Name</th>
                      <th scope="col">Type</th>
                      <th scope="col">IcaoCC</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let navaid of selectCoordinatePointService.selectedAirSpaceBoundary.navaids; let i = index" (click)="selectProcedureNavaid(navaid)"
                    [class.highlighted]="navaid.isselected">
                      <td>{{ navaid.navaidid }}</td>
                      <td>{{ navaid.name }}</td>
                      <td>{{ navaid.navaidtype }}</td>
                      <td>{{ navaid.icaocc }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="btn">
                <a (click)="addNavaidFromMap()">Add From Map</a>
                <a (click)="deleteSelectedNavaidsFromList()">Delete From List</a>
                <a (click)="selectNavaidRows()">Show in Map</a>
              </div>
            </div>
          </div>
      </div>

    </div>

  </form>

</div>
